import { createRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import localForage from 'localforage';
import { useTheme } from '@mui/material';
import { clearForm, saveSteps } from 'app/store/briisk/formSlice';
import { setParam } from 'utils/locationHistory';
import * as context from 'api/base';
import * as widgetContext from '../components/widgets/WidgetFactory';
import { getFlowSteps } from './generic/Helpers/HomePageHelper';
import { setiFramesRefsHeightDynamically } from './generic/Helpers/GenericHelper';
import { useStylesHome } from '../components/styles/widgetStyles';
import '@measured/puck/puck.css';
import { Render } from '@measured/puck';
import { PuckConfig } from '../components/puck/Config';

function MaintainancePage() {
	const dispatch = useDispatch();
	const pageData = context.getPageInfo();
	const channelSettings = context.getSettings();
	const navigate = useNavigate();
	const widgetList = widgetContext.WidgetFactory('maintenance');
	const referenceTokenDetails = useSelector(({ fuse }) => fuse.form.referenceTokenDetails);
	const channelProducts = useSelector(({ fuse }) => fuse.form.channelProducts?.value);

	// for rendring puckData on UI
	const channelPages = useSelector(({ fuse }) => fuse.form.channelSettings?.value?.channelPages);
	const puckData = channelPages?.find(({ pageType }) => pageType === '20')?.puckData || null;

	// eslint-disable-next-line
	const myRefs = Array.from({ length: widgetList?.length }, () => createRef(null));
	const theme = useTheme();
	const classes = useStylesHome(theme);

	// To set component iframe's height dynamically
	useEffect(() => {
		setiFramesRefsHeightDynamically(myRefs);

		// Fetching the iframe element
		const iframeElement = document.querySelector('.iframe');

		// Removing the scrollbars from the iframe(if found)
		if (iframeElement) {
			iframeElement.scrolling = 'no';
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Setting up reference token
	useEffect(() => {
		setParam(navigate, referenceTokenDetails?.token);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		dispatch(clearForm());
		dispatch(saveSteps([...getFlowSteps(channelSettings, channelProducts)]));
		localForage.removeItem('file');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, pageData]);

	return (
		<div className="flex flex-col flex-auto min-h-screen min-w-0 w-full relative">
			{!puckData ? (
				widgetList.map((tabItem, index) => (
					<div key={index}>
						{tabItem?.props?.headingTag === 'div' ? (
							<div>
								<iframe
									className="iframe"
									title={`Iframe-title-${index}`}
									id={`Iframe-id-${index}`}
									height={`${0}px`}
									ref={myRefs[index]}
									srcDoc={tabItem?.props?.mainTitle}
									style={{
										width: '100%',
										border: 'none',
										overflow: 'hidden'
									}}
								/>
							</div>
						) : (
							<div className={classes.tabItem}>
								<div className="mx-16 md:mx-60">{tabItem}</div>
							</div>
						)}
					</div>
				))
			) : (
				<Render config={PuckConfig} data={JSON.parse(puckData ?? '{}')} />
			)}
		</div>
	);
}

export default MaintainancePage;
